import { Component, input } from '@angular/core';
import { SvgName } from './types/svg-name.type';

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
})
export class SvgIconComponent {
  svgName = input.required<SvgName>();
  width = input.required<number>();
  height = input.required<number>();
  svgClass = input<string>();
}
